

<template>
  <!-- Header Area Start -->
  <div class="error-page-header-area">
    <div class="container">
      <div class="row justify-content-between">
        <div class="col-lg-4 col-sm-4">
          <div class="error-page-logo">
            <a href="/">
              <img src="../assets/img/logo_black.png" alt="Site Logo">
            </a>
          </div>
        </div>
        <div class="col-lg-8 col-sm-8">
          <div class="error-page-logo-right">
            <router-link to="/"><span class="fa fa-home"></span>back to home</router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- Header Area End -->
</template>
<script>
export default {
  name: 'PageHeader'
}
</script>



// WEBPACK FOOTER //
// src/layout/PageHeader.vue